import { render } from "./RememberDeviceComponent.vue?vue&type=template&id=5d2a35aa&scoped=true"
import script from "./RememberDeviceComponent.vue?vue&type=script&lang=js"
export * from "./RememberDeviceComponent.vue?vue&type=script&lang=js"

import "./RememberDeviceComponent.vue?vue&type=style&index=0&id=5d2a35aa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2125467209/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2a35aa"]])

export default __exports__